<template>
  <div class="agreement">
    <div class="agreement__wrap">
      <div class="agreement__modal">
        <div class="agreement__title">
          {{ $t('admin.agreement.title') }}
        </div>
        <div
          class="agreement__content"
          v-if="settings && settings.agreement_ru"
          v-html="settings.agreement_ru"
        ></div>
        <div class="agreement__actions">
          <div class="agreement__checkbox">
            <div class="checkbox__input">
              <button
                class="rounded flex items-center focus:outline-none gap-2"
                @click="checked = !checked"
              >
                <span class="check"><i
                    v-if="checked"
                    class="fas fa-check text-red-500"
                  ></i></span>
              </button>
            </div>
            <div
              @click="checked = !checked"
              class="checkbox__text"
              v-html="$t('admin.agreement.text_accept')"
            ></div>
          </div>
          <div class="agreement__buttons">
            <button
              :disabled="!checked"
              class="agreement__ok"
              @click="
                $store.dispatch('settings/set', {
                  key: 'accept_agreement',
                  value: '1',
                })
              "
            >
              {{ $t('admin.agreement.button_yes') }}
            </button>
            <button
              class="agreement__no"
              @click="decline"
            >
              {{ $t('admin.agreement.button_no') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Agreement",
  data() {
    return {
      checked: false,
    };
  },
  methods: {
    decline() {
      this.$store.dispatch("settings/set", {
        key: "accept_agreement",
        value: "0",
      });
      localStorage.removeItem("auth_token");
      location.reload();
    },
  },
  computed: {
    settings() {
      return this.$store.state.settings.settings;
    },
  },
};
</script>
<style scoped>
.agreement__wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  z-index: 101;
}
.agreement__modal {
  background-color: #fff;
  border-radius: 4px;
  padding: 21px;
  box-shadow: 0 0 40px rgba(66, 66, 66, 0.8);
  width: 65%;
  margin: auto;
}
.agreement__title {
  font-size: 24px;
  margin-bottom: 15px;
}
.agreement__content {
  height: 390px;
  overflow-y: scroll;
  font-size: 13px;
}
.agreement__content p {
  margin-bottom: 12px;
}
.agreement__actions {
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}
.agreement__checkbox {
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.agreement__buttons {
  white-space: nowrap;
}
.agreement__buttons button {
  font-size: 18px;
  line-height: 1;
  padding: 8px;
  border-radius: 3px;
}
button.agreement__ok {
  background-color: #3fb964;
  border: 1px #3fb964 solid;
  color: #fff;
  margin-right: 13px;
}
button.agreement__ok:disabled {
  background-color: rgba(66, 66, 66, 0.2);
  border-color: rgba(66, 66, 66, 0.4);
  cursor: default;
}
button.agreement__no {
  background-color: #ecf1f3;
  border: 1px #cfe2e8 solid;
}
.checkbox__text {
  cursor: pointer;
}
</style>
